import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-6 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-14">
          <div>
            <h3 className="font-heading text-3xl md:text-4xl text-background-50 mb-6">
              GTBuy Spreadsheet
            </h3>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-xs">
              The structured sourcing system built for modern ecommerce sellers. Compare suppliers, track pricing, and optimize your dropshipping workflow with a clean, spreadsheet-based approach.
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-wider text-foreground-400 font-medium mb-5">
              Quick Links
            </h4>
            <div className="space-y-3">
              <Link
                to="/"
                className="block text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer"
              >
                Home
              </Link>
              <Link
                to="/what-is-gtbuy-spreadsheet"
                className="block text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer"
              >
                What is GTBuy Spreadsheet
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="block text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer"
              >
                KA Spreadsheet
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-wider text-foreground-400 font-medium mb-5">
              Shop Categories
            </h4>
            <div className="space-y-3">
              <a
                href="https://kaspreadsheet.com/category-911-Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="block text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer"
              >
                Shoes
              </a>
              <a
                href="https://kaspreadsheet.com/search-913/name/Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="block text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer"
              >
                T-Shirts
              </a>
              <a
                href="https://kaspreadsheet.com/search-914/name/Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="block text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer"
              >
                Jackets
              </a>
              <a
                href="https://kaspreadsheet.com/search-920/name/Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="block text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer"
              >
                Accessories
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} GTBuy Spreadsheet. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/what-is-gtbuy-spreadsheet"
              className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer"
            >
              Blog
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer"
            >
              Privacy
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer"
            >
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}